import { Box, HStack, IconButton, Text } from '@chakra-ui/react';
import * as React from 'react';

import { PaperclipIcon, XIcon } from '@/imports/ui/chakra/feather';

export const FileUploadPreviewItem: React.FC<{
  versionFileId: string;
  fileName: string;
  onClick: (value: { versionFileId: string }) => void;
}> = (props) => {
  return (
    <HStack width="full" alignItems="start">
      <Box
        borderRadius="xl"
        border="1px"
        borderColor="gray.200"
        display="flex"
        p="4"
        alignItems="center"
        flex="1"
      >
        <PaperclipIcon color="gray.500" boxSize={4} mr="4" />
        <Box>
          <Text fontWeight="semibold" mr="4" color="gray.700">
            {props.fileName}
          </Text>
        </Box>
      </Box>
      <IconButton
        colorScheme="gray"
        icon={<XIcon />}
        aria-label="Remove File"
        onClick={() => props.onClick({ versionFileId: props.versionFileId })}
        size="xs"
        borderRadius="full"
      />
    </HStack>
  );
};
